import { getToken } from '@/utils/auth'
import { Toast } from 'vant'
import { STORAGE_KEYS } from '@/constants/appIdentity'

/** 本项目客服 token 本地键（跨域客服页仍通过 ?token= 传递） */
export const SUPPORT_TOKEN_KEY = STORAGE_KEYS.supportToken

/** 官方客服聊天页 */
const DEFAULT_SUPPORT_CHAT_URL =
  'https://www.zhangjianjmhqing.shop/user/support/chat-page/'

export const SUPPORT_CHAT_URL = (
  process.env.VUE_APP_SUPPORT_CHAT_URL || DEFAULT_SUPPORT_CHAT_URL
).trim()

/**
 * 把 App 登录拿到的 access 写入客服约定 key。
 * 客服页据此请求：
 *   GET /user/support/conversation/
 *   Authorization: Bearer <access>
 */
export function syncSupportAccessToken(accessToken) {
  if (!accessToken) return
  try {
    localStorage.setItem(SUPPORT_TOKEN_KEY, accessToken)
  } catch (e) {
    // ignore
  }
}

export function clearSupportAccessToken() {
  try {
    localStorage.removeItem(SUPPORT_TOKEN_KEY)
  } catch (e) {
    // ignore
  }
}

/**
 * 拼接客服页地址。
 * 跨域时附加 ?token=，便于客服域 H5 写入本域的 support_user_access_token。
 */
export function buildSupportChatUrl(accessToken) {
  const base = SUPPORT_CHAT_URL.replace(/\/+$/, '')
  const url = new URL(`${base}/`)
  if (accessToken) {
    url.searchParams.set('token', accessToken)
  }
  return url.toString()
}

/**
 * 打开在线客服：
 * 1. 取 App 登录 access
 * 2. 写入 localStorage.support_user_access_token
 * 3. 打开客服 H5（跨域带 ?token=）
 */
export function openSupportChat(options = {}) {
  const accessToken = getToken()
  if (!accessToken) {
    const message = options.loginMessage || '请先登录后再联系客服'
    if (typeof options.onNeedLogin === 'function') {
      options.onNeedLogin(message)
    } else {
      Toast(message)
    }
    return false
  }

  syncSupportAccessToken(accessToken)

  const chatUrl = buildSupportChatUrl(accessToken)
  if (options.newWindow) {
    window.open(chatUrl, '_blank')
  } else {
    window.location.href = chatUrl
  }
  return true
}
